import React from "react";
import "./EcoSysSecOne.css";
import { HashLink as Link } from "react-router-hash-link";
import ellipse_Left from "../EcoSysImages/Ellipse_Left.png";
import ellipse_Right from "../EcoSysImages/Ellipse_Right.png";
export default function EcoSysSecOne() {
  return (
    <section className="eco-hero" aria-labelledby="eco-hero-title">
      <img
        src={ellipse_Left}
        alt=""
        aria-hidden="true"
        className="eco-hero__ellipse eco-hero__ellipse--left"
      />
      <img
        src={ellipse_Right}
        alt=""
        aria-hidden="true"
        className="eco-hero__ellipse eco-hero__ellipse--right"
      />
      <div className="eco-hero__content">
        <div className="eco-hero__tabs" aria-hidden="true">
          <span className="eco-hero__tab-static">Quests</span>
          <span className="eco-hero__tab-static">AI</span>
          <span className="eco-hero__tab-static">Wall</span>
          <span className="eco-hero__tab-static">Profile</span>
        </div>
        <h1 id="eco-hero-title" className="eco-hero__title">
          Welcome To 3VO
        </h1>
        <p className="eco-hero__sub">
          Create, level up, and share your journey every day.
        </p>
        {/* <button className="eco-hero__btn">Get Started</button> */}
        {/* <div className="token-btn-two-eco">
          <div className="token-btn-wrapper-eco">
            <Link smooth to="/#get3voApp" className="text-wrapper-cta">
              <div className="text-wrapper-cta-token">Get Started</div>
            </Link>
          </div>
        </div> */}
        <div className="eco-one-section-button">
          <Link to="/#get3voApp" onClick={() => window.scrollTo(0, 0)}>
            <div className="create-token-btn-eco">
              <p className="create-token-btn-text">Get Started</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
